import { useState } from 'react';
import { Form } from 'react-bootstrap';

import { formatGachaDuration, parseGachaDuration } from '../utils';

type Props = {
  id: string;
  // Seconds; null = not set yet.
  value: number | null;
  onChange: (seconds: number | null) => void;
};

/**
 * A `Day, HH:MM:SS` interval (e.g. `1, 00:00:00` = one day), stored as seconds. The text is kept as typed while
 * it does not parse, and the parsed seconds are shown beneath.
 */
export function GachaDurationInput({ id, value, onChange }: Props): JSX.Element {
  const [text, setText] = useState(() => formatGachaDuration(value));
  const parsed = parseGachaDuration(text);
  const invalid = parsed === null || parsed < 1;

  return (
    <>
      <Form.Control
        id={id}
        value={text}
        placeholder="Day, HH:MM:SS"
        isInvalid={invalid}
        onChange={(e) => {
          setText(e.target.value);
          onChange(parseGachaDuration(e.target.value));
        }}
        onBlur={() => {
          if (parsed !== null) {
            setText(formatGachaDuration(parsed));
          }
        }}
      />
      {invalid ? (
        <Form.Control.Feedback type="invalid">
          Use Day, HH:MM:SS (hours 0-23), at least 1 second. Example: 1, 00:00:00 = one day.
        </Form.Control.Feedback>
      ) : (
        <Form.Text className="text-muted">= {parsed} seconds</Form.Text>
      )}
    </>
  );
}
